export default function useReserveButtonState({
  selectedDates,
  selectedSpot,
  userReservedDates,
  userId,
  autoAssignEnabled = false // domyślnie false
}) {
  const selectedDateStrings = selectedDates.map(d =>
    new Date(d).toISOString().split("T")[0]
  );

  if (autoAssignEnabled) {
    const availableDates = selectedDateStrings.filter(
      date => !userReservedDates.includes(date)
    );

    const canReserve =
      typeof userId === "number" && availableDates.length > 0;

    let label = "SZYBKA REZERWACJA";

    if (availableDates.length === 0) {
      label = "BRAK MOŻLIWOŚCI REZERWACJI";
    } else if (availableDates.length > 1) {
      label = `SZYBKA REZERWACJA (${availableDates.length} dni)`;
    }

    return { canReserve, label };
  }

  // ⬇️ Tryb klasyczny – bez zmian
  const spotReservations = selectedSpot?.reservations || [];

  const datesTakenByOthers = selectedDateStrings.filter(date =>
    spotReservations.some(r => r.date === date && r.userId !== userId)
  );

  const datesAlreadyMine = selectedDateStrings.filter(date =>
    userReservedDates.includes(date)
  );

  const availableDates = selectedDateStrings.filter(
    date =>
      !datesTakenByOthers.includes(date) &&
      !datesAlreadyMine.includes(date)
  );

  const alreadyHasSome =
    availableDates.length < selectedDateStrings.length &&
    availableDates.length > 0;

  const canReserve =
    !!selectedSpot && typeof userId === "number" && availableDates.length > 0;

  let label = "ZAREZERWUJ";

  if (!selectedSpot) {
    label = "WYBIERZ MIEJSCE";
  } else if (availableDates.length === 0) {
    label = "BRAK MOŻLIWOŚCI REZERWACJI";
  } else if (alreadyHasSome) {
    label = `ZAREZERWUJ WOLNE (${availableDates.length} dni)`;
  } else if (availableDates.length > 1) {
    label = `ZAREZERWUJ (${availableDates.length} dni)`;
  }

  return {
    canReserve,
    label
  };
}
